import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import ComplianceTermsModal from '../ComplianceTermsModal';
import { useAppSelector } from '../../store/hooks';
import { COMPLIANCE } from '../../constants/auth';

interface ComplianceTermsGuardProps {
  children: ReactNode;
  fallback?: ReactNode;
  requireReadyForCompliance?: boolean;
}

const ComplianceTermsGuard = ({
  children,
  fallback = null,
  requireReadyForCompliance = false,
}: ComplianceTermsGuardProps) => {
  const selectedCompany = useAppSelector((state) => state.companyUser.companyUser?.selectedCompany);

  if (!selectedCompany) {
    return <>{fallback}</>;
  }

  const { readyForCompliance, hasStartedCompliance } = selectedCompany.productStatus;

  if (requireReadyForCompliance && !readyForCompliance) {
    return <Navigate to={COMPLIANCE} replace />;
  }

  if (readyForCompliance && !hasStartedCompliance) {
    return (
      <>
        {fallback}
        <ComplianceTermsModal isOpen />
      </>
    );
  }

  return <>{children}</>;
};

export default ComplianceTermsGuard;
